/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, optional as codecOptional } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { QualityTestLogBase } from './QualityTestLogBase';
const QualityTestLogParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['points', /* #__PURE__ */ codecOptional(codecNumber)],
]), QualityTestLogBase);
export class QualityTestLog extends QualityTestLogBase {
    static decode(input) {
        return QualityTestLogParser.decode(input).map(res => new QualityTestLog(res));
    }
    static unsafeDecode(input) {
        return QualityTestLog.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return QualityTestLogParser.encode(data);
    }
    static schema() {
        return QualityTestLogParser.schema();
    }
}
